import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import Reasons from '../../../components/Reasons/Reasons';
import Testimonials from '../../../components/Testimonials/Testimonials';

class IndividualsFamilies extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Individuals/Families',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <Reasons />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=New York State of Health - Individuals & Families' />
        <Testimonials heading='&ldquo;CDPHP treats you like someone they know and care about.&rdquo;' slides='consumer'>
          <p className='text-center'><Link to='/find-a-plan/' className='btn alt lg'>Find a Plan</Link></p>
        </Testimonials>
      </Aux>
    );
  }
}

IndividualsFamilies.propTypes = { // validate props expected
};

export default IndividualsFamilies;



// WEBPACK FOOTER //
// ./src/containers/Views/Landing/IndividualsFamilies.jsx